import { call, put, takeLatest } from 'redux-saga/effects';

import { InsurancePolicyUserApi } from '@apis/InsurancePolicyUserApi';
import { InsurancePolicyUser } from '@models/InsurancePolicyUser';
import { SagaPayload } from '@utils/typescript';

import {
  insurancePolicyUserFetch,
  InsurancePolicyUserFetchPayload,
  insurancePolicyUserHealthBenefitLimitsFetch,
  InsurancePolicyUserHealthBenefitLimitsFetchPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';
import { BenefitLimit } from '@models/BenefitLimit';

function* handleInsurancePolicyUserFetch({ payload }: SagaPayload<InsurancePolicyUserFetchPayload>) {
  const state: StateUpdatePayload = { policyUser: null };
  try {
    state.policyUser = (yield call(InsurancePolicyUserApi.get, payload)) as InsurancePolicyUser;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleInsurancePolicyUserHealthBenefitLimitsFetch({ payload }: SagaPayload<InsurancePolicyUserHealthBenefitLimitsFetchPayload>) {
  const state: StateUpdatePayload = { healthBenefitLimitsWithAccumulatedPaidAmounts: null };
  try {
    state.healthBenefitLimitsWithAccumulatedPaidAmounts = (yield call(InsurancePolicyUserApi.getHealthBenefitLimitsWithAccumulatedPaidAmounts, payload)) as BenefitLimit[];
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(insurancePolicyUserFetch, handleInsurancePolicyUserFetch);
  yield takeLatest(insurancePolicyUserHealthBenefitLimitsFetch, handleInsurancePolicyUserHealthBenefitLimitsFetch);
}
